import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';
import { IVesselInformationMySuffix } from 'src/app/shared/model/vessel-information-my-suffix.model';

type EntityResponseType = HttpResponse<IVesselInformationMySuffix>;
type EntityArrayResponseType = HttpResponse<IVesselInformationMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class VesselInformationMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/vessel-informations';
    private ihsResourceUrl = SERVER_API_URL + 'api/ihs-vessel-informations';
    private createAllURL = SERVER_API_URL + 'api/csv/vessel-informations';
    private imoVesselInformationURL = SERVER_API_URL + 'api/vessel-screening-detail';
    private _policyIdOfPolicyHolder = SERVER_API_URL + "api/policies/policyHolder";
    constructor(private http: HttpClient) {}

    create(vesselInformation: IVesselInformationMySuffix): Observable<EntityResponseType> {
        return this.http.post<IVesselInformationMySuffix>(this.resourceUrl, vesselInformation, { observe: 'response' });
    }

    update(vesselInformation: IVesselInformationMySuffix): Observable<EntityResponseType> {
        return this.http.put<IVesselInformationMySuffix>(this.resourceUrl, vesselInformation, { observe: 'response' });
    }

    createAll(vesselInformations: IVesselInformationMySuffix[]): Observable<EntityResponseType> {
        return this.http.post<IVesselInformationMySuffix>(this.createAllURL, vesselInformations, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IVesselInformationMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
    findVesselImoInformation(id: number): Observable<any> {
        return this.http.get<any>(`${this.imoVesselInformationURL}/${id}`, { observe: 'response' });
    }
    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IVesselInformationMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' });
    }
    IHSquery(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IVesselInformationMySuffix[]>(this.ihsResourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    uploadVesselInfoService(fileData: any): Observable<EntityResponseType> {
        const _url = SERVER_API_URL + 'api/vessel-infos/file/save';
        return this.http.post<IVesselInformationMySuffix>(_url, fileData, { observe: 'response' });
    }
    //ihs-vessel-informations-imo
    findImosByName(name: string): Observable<HttpResponse<any>> {
        return this.http.post<any>(`${this.resourceUrl+'-imo'}`,{name:name}, { observe: 'response' });
    }

    findIHSImosByName(name: string): Observable<HttpResponse<any>> {
        return this.http.post<any>(`${ SERVER_API_URL + 'api/ihs-vessel-informations-imo'}`,{name:name}, { observe: 'response' });
    }

    post(url:string,data:any): Observable<HttpResponse<any>> {
        return this.http.post<any>( SERVER_API_URL + 'api/'+url, data, { observe: 'response' });
    }

    get(url:string):Observable<HttpResponse<any>> {
        return this.http.get<any>(SERVER_API_URL + 'api/'+url, { observe: 'response' });
    }


    getTraderClient(url:string):Observable<HttpResponse<any>> {
        return this.http.get<any>(SERVER_API_URL + 'api/'+url, { observe: 'response' });
    }


    getWithPageAble(url:string,req:any):Observable<HttpResponse<any>> {
        const options = createRequestOption(req);
        return this.http.get<any>(SERVER_API_URL + 'api/'+url, { params: options, observe: 'response' });
    }
    // /{policyHolderId}
    getPolicyOfPolicyHolder(policyHolderId: number):Observable<any>{
        return this.http.get<any>(`${this._policyIdOfPolicyHolder}/${policyHolderId}`, {
            observe: 'response'
        });
    }
    
}
